import Header from './components/Header'
import Hero from './components/Hero'
import WorkflowSection from './components/WorkflowSection'
import FeatureSection from './components/FeatureSection'
import CtaSection from './components/CtaSection'
import Footer from './components/Footer'

/** Vistoera SaaS Landing Page — Phase SAAS-ENTRY-A1 §8-§15. Composition
 * only; every section is its own component so Feature/Workflow copy can
 * be revised independently without touching layout. */
export default function LandingPage() {
  return (
    <div className="mkt">
      <Header />
      <main>
        <Hero />
        <WorkflowSection />
        <FeatureSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  )
}
